import { adminService } from '../../services';
import type { UnwrapData } from '../../types';

import type { IBlocksVisibility, IMainPageVersionResponse, IMainPageVersionsResponse } from './types';

export const mainPagesService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить список версий главной страницы
     */
    getMainPages: builder.query<UnwrapData<IMainPageVersionsResponse>, void>({
      query: () => ({
        method: 'GET',
        url: '/main_pages',
      }),
      transformResponse: (response: IMainPageVersionsResponse): UnwrapData<IMainPageVersionsResponse> => response.data,
      providesTags: ['MainPages'],
    }),
    /**
     * Получить данные о конкретной версии главной страницы
     */
    getMainPage: builder.query<UnwrapData<IMainPageVersionResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/main_pages/${id}`,
      }),
      transformResponse: (response: IMainPageVersionResponse): UnwrapData<IMainPageVersionResponse> => response.data,
      providesTags: ['MainPage'],
    }),
    /**
     * Создать новую версию главной страницы
     */
    createMainPage: builder.mutation<UnwrapData<IMainPageVersionResponse>, void>({
      query: () => ({
        method: 'POST',
        url: `/main_pages`,
      }),
      transformResponse: (response: IMainPageVersionResponse): UnwrapData<IMainPageVersionResponse> => response.data,
      invalidatesTags: ['MainPages'],
    }),
    /**
     * Обновить версию главной страницы
     */
    updateMainPage: builder.mutation<IMainPageVersionResponse, { id: number; data: IBlocksVisibility }>({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/main_pages/${id}`,
        body: {
          data: {
            blocks_visibility: data,
          },
        },
      }),
      invalidatesTags: ['MainPages', 'MainPage'],
    }),
    /**
     * Удалить версию главной страницы
     */
    deleteMainPage: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        method: 'DELETE',
        url: `/main_pages/${id}`,
      }),
      invalidatesTags: ['MainPages'],
    }),
    /**
     * Опубликовать версию главной страницы
     */
    publishMainPage: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({
        method: 'POST',
        url: `/main_pages/${id}/publish`,
      }),
      invalidatesTags: ['MainPages', 'MainPage'],
    }),
  }),
});

export const {
  useGetMainPagesQuery,
  useGetMainPageQuery,
  useCreateMainPageMutation,
  useUpdateMainPageMutation,
  useDeleteMainPageMutation,
  usePublishMainPageMutation,
} = mainPagesService;
